import chatbotRequest from '../http'
import type { CreateLineChannelReq, CreateLineChannelRes } from '../types/createLineChannel'

export function createLineChannelApi(data: CreateLineChannelReq): Promise<CreateLineChannelRes> {
    return chatbotRequest<CreateLineChannelRes, CreateLineChannelReq, CreateLineChannelRes>({
        url: '/api/channel/create/line',
        method: 'post',
        data,
    })
}